import { FC, useCallback, useEffect, useState } from "react";
import { Column } from "../../../components/containers";
import { Heading, Text } from "../../../components/typography";
import { LoginTextInput } from "../inputs";
import { EyeSlashIcon, UserIcon } from "../../../assets/icons";
import { Button } from "../buttons";
import { UserApi, type ApiError } from "../../../api";
import { useUserStore } from "../../../stores";
import { setCookie } from "../../../utils";
import { useNavigate } from "react-router";

const LoginForm: FC = () => {
  const setUser = useUserStore((s) => s.setUser);

  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  const [loading, setLoading] = useState<boolean>(false);

  const navigate = useNavigate();

  const onLogin = useCallback(() => {
    if (!username || !password) return;
    setLoading(true);
    UserApi.login(username, password)
      .then((res) => {
        setUser(res.data);
        setCookie("token", res.headers["x-auth"]);
        navigate("/");
      })
      .catch((error: ApiError) => {
        console.log(error); // show error to enemy :)
      })
      .finally(() => {
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [username, password]);

  const onKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Enter" && !loading) onLogin();
    },
    [onLogin, loading]
  );

  useEffect(() => {
    window.addEventListener("keydown", onKeyDown);
    return (): void => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [onKeyDown]);

  return (
    <Column style={styles.container}>
      <Heading color="white">نرم افزار مدیریتی چک ها</Heading>
      <Heading size={30} color="white" textStyles={{ marginBottom: "2rem" }}>
        ورود به حساب کاربری
      </Heading>
      <LoginTextInput
        label="نام کاربری"
        value={username}
        setValue={setUsername}
        Icon={UserIcon}
        style={{ marginBottom: "1rem" }}
      />
      <LoginTextInput
        label="رمز عبور"
        value={password}
        setValue={setPassword}
        Icon={EyeSlashIcon}
        password
        style={{ marginBottom: "1rem" }}
      />
      <Text
        color="grey"
        textStyles={{ marginBottom: "0.5rem", width: "80%", maxWidth: 460 }}
      >
        نام کاربری و رمز عبور را از مدیر شرکت یا مجموعه خود تحویل بگیرید .
      </Text>
      <Button loading={loading} onClick={onLogin}>
        ورود به حساب
      </Button>
    </Column>
  );
};

export default LoginForm;

const styles: Record<string, React.CSSProperties> = {
  container: {
    zIndex: 99,
    width: "100%",
  },
};
